import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'

export const Box = props => {
    useStyles(classes)
    return <div ref={props.innerRef} className={`${classes.Box} ${props.className}`}>
        {props.children}
    </div>
}

export const Boxes = props => {
    useStyles(classes)
    return <div className={`${classes.Boxes} ${props.className}`}>
        {props.children}
    </div>
}

export const NBoxes = props => {
    useStyles(classes)
    return <div className={`${classes.Boxes} ${classes.NBoxes} ${props.className}`}>
        {props.children}
    </div>
}